<template>
  <div>
    <b-overlay :show="wait" rounded="sm">
      <PageWrapper :items="navItems" :fields="infoFields">
        <template v-slot:content>
          <div>
            <TestViewContent ref="testViewContent" :isStarted="isStarted" :timer="timer"></TestViewContent>
          </div>
        </template>
        <template v-slot:other-buttons>
          <div>
            <b-button
              class="custom-button three"
              style="margin-bottom: 10px"
              @click="submitAndJudge"
            >评分</b-button>
            <b-button class="custom-button end-button" @click="showAskLeaveModal">结束练习</b-button>
          </div>
        </template>
      </PageWrapper>
      <TestResultModal
        :modalName="'testResultModal'"
        :timer="timer"
        :showQuestionnaireModal="showQuestionnaireModal"
        :showNotifyCompleteModal="showNotifyCompleteModal"
        :showPracticeView="showPracticeView"
        :resetTimer="resetTimer"
        ref="testResultModal"
      />
      <RemindModal :modalName="'askLeaveModal'" :modalHeight="'150px'" ref="askLeaveModal">
        <template v-slot:header>
          <span>{{ askLeaveModalHeader }}</span>
        </template>
        <template v-slot:body>
          <p>{{ askLeaveModalBody }}</p>
        </template>
        <template v-slot:buttons>
          <b-row>
            <b-col md="1" sm="0"></b-col>
            <b-col md="5" sm="6">
              <b-button class="custom-button five" @click="endAndLeave">{{$t('Common.yes')}}</b-button>
            </b-col>
            <b-col md="5" sm="6">
              <b-button
                class="custom-button four"
                @click="closeAskLeaveModal"
              >{{$t('Common.cancel')}}</b-button>
            </b-col>
            <b-col md="1" sm="0"></b-col>
          </b-row>
        </template>
      </RemindModal>
      <b-modal ref="notifyCompleteModal" hide-footer title="提示" no-close-on-backdrop no-close-on-esc hide-header-close>
        <div class="d-block text-center">
          <h3>{{ $t('Vocabulary.notifyCompleteGlossary') }}</h3>
        </div>
        <b-button class="mt-3" variant="outline-success" block @click="hideNotifyCompleteModal">回到练习设定</b-button>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageWrapper from '../../PageWrapper/PageWrapper'
import TestViewContent from './TestViewContent.vue'
import TestResultModal from './TestResultModal.vue'
import RemindModal from '../../CustomModal/RemindModal.vue'
import { secondToHMS } from '../../../util/time'
import Timer from '../../../util/Timer'
import hotkeys from 'hotkeys-js'
import { MODES } from '../vocabularyMode'

export default {
  name: 'PracticeView',
  components: {
    PageWrapper,
    TestViewContent,
    TestResultModal,
    RemindModal
  },
  props: {
    showQuestionnaireModal: {
      type: Function,
      required: true
    },
    showPracticeView: {
      type: Function,
      required: true
    }
  },
  watch: {
    toStartTest (newValue, oldValue) {
      if (newValue !== oldValue && newValue === true) {
        this.timer = new Timer()
        this.isStarted = true
        this.$store.commit('vocabularyPractice/setTestCorrectCount', 0)
        this.timer.startTimer()
      }
    },
    remainingTime (newValue) {
      if (newValue === 0) {
        this.submitAndJudge()
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.onKeydown)

    hotkeys('enter', (e) => {
      e.preventDefault()
    })

    this.timer = new Timer()
    if (this.toStartTest) {
      this.$store.commit('vocabularyPractice/setTestCorrectCount', 0)
      this.isStarted = true
      this.timer.startTimer()
    }
  },
  data () {
    return {
      isStarted: false,
      timer: new Timer(),
      askLeaveModalHeader: '',
      askLeaveModalBody: ''
    }
  },
  computed: {
    ...mapState({
      wait: (state) => state.glossary.waitForFetching,
      ruleList: state => state.vocabularyPractice.ruleList,
      currentRule: (state) => state.vocabularyPractice.currentRule,
      wordList: (state) => state.vocabularyPractice.testWordList,
      toStartTest: (state) => state.vocabularyPractice.toStartTest,
      mode: (state) => state.vocabularyPractice.mode,
      currentExam: state => state.exam.currentExam
      // examReviewAfterFirstPractice: state => state.vocabularyPractice.examReviewAfterFirstPractice
    }),
    navItems () {
      let modeLabel = this.mode
      switch (this.mode) {
        case 'LEARNNEW': modeLabel = this.$t('Vocabulary.learnNew')
          break
        case 'REVIEW': modeLabel = this.$t('Vocabulary.review')
          break
        case 'FORCEREVIEW': modeLabel = this.$t('Vocabulary.forceReview')
          break
        case 'EXAMSIMULATION': modeLabel = this.$t('Vocabulary.examSimulation')
          break
        case 'EXAM': modeLabel = this.$t('Vocabulary.exam')
          break
      }
      return [
        {
          label: '字汇',
          link: 'vocabulary'
        },
        {
          label: modeLabel
        },
        {
          label: '全民英检'
        }
      ]
    },
    infoFields () {
      return [
        {
          label: '题数',
          value: `共 ${this.wordList.length} 题`
        },
        {
          label: '剩余时间',
          value: secondToHMS(this.remainingTime)
        }
      ]
    },
    remainingTime () {
      if (this.timer.timeElapsed) {
        let totalSeconds = 0
        // if (this.mode === 'EXAMREVIEW' && this.examReviewAfterFirstPractice) {
        //   totalSeconds = this.ruleList.find(rule => rule.mode === 'REVIEW').time_limit_for_one * this.wordList.length
        // } else
        if (MODES.EXAM.includes(this.mode) && this.currentExam) {
          totalSeconds = this.currentExam.duration * 60
        } else if (this.currentRule) {
          totalSeconds = this.currentRule.time_limit_for_one * this.wordList.length
        }
        return totalSeconds - this.timer.timeElapsed / 1000
      }

      return null
    }
  },
  methods: {
    submitAndJudge () {
      this.timer.stopTimer()
      this.isStarted = false
      this.$refs.testViewContent.submit()
      this.$refs.testResultModal.showModal()
    },
    resetTimer () {
      this.timer = new Timer()
    },
    showAskLeaveModal () {
      this.askLeaveModalHeader = this.$t('Common.notice')
      this.askLeaveModalBody = this.$t('Common.askLeave')
      this.timer.stopTimer()
      this.$refs.askLeaveModal.showModal()
      this.askLeaveModalIsHidden = false
    },
    showNotifyCompleteModal () {
      this.$refs['notifyCompleteModal'].show()
    },
    hideNotifyCompleteModal () {
      this.$refs['notifyCompleteModal'].hide()
      this.endAndLeave()
    },
    endAndLeave () {
      this.timer.stopTimer()
      this.$store.commit('vocabularyPractice/resetAll')
      this.$store.commit('vocabularyPractice/setLeave', true)
      this.isStarted = false
      this.$router.replace('/vocabulary')
    },
    closeAskLeaveModal () {
      this.$refs.askLeaveModal.closeModal()
      this.timer.startTimer()
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
